import Column from '@app/components/layout/Column'
import {
  faLocationDot,
  faCalendar,
  faClock,
} from '@fortawesome/pro-light-svg-icons'
import { useLanguage, useTranslations } from '@i18n/useLanguage'
import { Card } from '@app/components/blocks/card/Card'
import { SocialShareModal } from '@app/components/blocks/modal/SocialShareModal'
import { useMemo, useState } from 'react'
import { IconList } from '@app/components/blocks/iconList/IconList'
import { Button } from '@app/components/core/button/Button'
import { ViewEventModel } from 'functions/app/event/view'

export const DataCard = ({ event }: { event: ViewEventModel }) => {
  const [language, _] = useLanguage()
  const t = useTranslations().app.eventPage
  const [shareEventModal, setShareEventModal] = useState(false)
  const startDate = useMemo(() => new Date(event.start), [event.start])
  const endDate = useMemo(() => new Date(event.end), [event.end])

  return (
    <>
      <Card
        style={{
          padding: 0,
        }}
        contentStyle={{
          padding: '1.5rem',
        }}
      >
        <Column
          gap="1.5rem"
          alignItems="stretch"
          style={{ height: '100%', justifyContent: 'space-between' }}
        >
          <IconList
            items={[
              {
                icon: faLocationDot,
                text: event.location?.address ?? 'Not specified',
              },
              {
                icon: faCalendar,
                text: startDate.toLocaleDateString(language, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                }),
              },
              {
                icon: faClock,
                text: `${startDate.toLocaleTimeString(language, {
                  hour: '2-digit',
                  minute: '2-digit',
                })} - ${endDate.toLocaleTimeString(language, {
                  hour: '2-digit',
                  minute: '2-digit',
                })}`,
              },
            ]}
          />
          <Button to={event.link} label={t.openInLuma} />
        </Column>
      </Card>

      <SocialShareModal
        isOpen={shareEventModal}
        onClose={() => setShareEventModal(false)}
        title={event.title}
      />
    </>
  )
}
